import type { IconSvgObject } from './types';

const RectangleCircleIcon: IconSvgObject = [
  ["circle", { cx: "14", cy: "12", r: "8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 18V6C2 4.89543 2.89543 4 4 4H14V20H4C2.89543 20 2 19.1046 2 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RectangleCircleIcon;
